/**
 * Front route declaration, with their associated component
 * @see {@link https://router.vuejs.org/guide/essentials/named-routes.html|Vue Router Named Route}
 */

import Dashboard from 'vcomponents/dashboard/Dashboard.vue';
import DeveloperPortal from 'vcomponents/developerPage/DeveloperPortal.vue';
import DeveloperApiV2 from 'vcomponents/developerPage/ApiV2.vue';
import DeveloperMyApps from 'vcomponents/developerPage/MyApps.vue';
import DeveloperThirdPartyApps from 'vcomponents/developerPage/ThirdPartyApps.vue';
import DeveloperWebhooks from 'vcomponents/developerPage/Webhooks.vue';
import DeveloperWidgets from 'vcomponents/developerPage/Widgets.vue';

export default [
    {
        path: '/home/',
        name: 'dashboard',
        component: Dashboard,
        props: true,
        meta: {
            menuId: 'dashboard',
            fullMenu: true,
            title: window.i18n.__('Tableau de bord'),
        },
    },
    {
        path: '/developer',
        name: 'developerPortal',
        component: DeveloperPortal,
        props: true,
        meta: {
            title: window.i18n.__('Portail Développeur'),
        },
        children: [
            {
                path: 'my-apps',
                name: 'my-apps',
                component: DeveloperMyApps,
            },
            {
                path: 'api-v2',
                name: 'api-v2',
                component: DeveloperApiV2,
            },
            {
                path: 'third-party-apps',
                name: 'third-party-apps',
                component: DeveloperThirdPartyApps,
            },
            {
                path: 'webhooks',
                name: 'webhooks',
                component: DeveloperWebhooks,
            },
            {
                path: 'widgets',
                name: 'widgets',
                component: DeveloperWidgets,
            },
        ],
    },
    {
        path: '/search',
        name: 'search',
    },
];
